import { ShipperResource } from 'app/_resources/shipper.resource';
import { AuthService } from 'app/_services/auth.service';
import * as angular from 'angular';
import { mgoAngularWizard } from '../custom';

class ShipperPremiumServicesWizardSepaMandateComponentCtrl
    implements ng.IController
{
    wizardCtrl: mgoAngularWizard.Wizard<ShipperPremiumServiceSubscriptionCreationDto>;
    debtor: ShipperPremiumServiceBillingAddressCreationDto;

    constructor(
        private Shipper: ShipperResource,
        private authService: AuthService
    ) {}

    get shipper(): Shipper {
        return this.wizardCtrl.currentStep().wzData.shipper;
    }

    get authUser(): LoginResult {
        return this.wizardCtrl.currentStep().wzData.authUser;
    }

    get confirmSepaMandate(): boolean {
        return this.wizardCtrl.currentStep().wzData.confirmSepaMandate;
    }

    set confirmSepaMandate(value: boolean) {
        this.wizardCtrl.currentStep().wzData.confirmSepaMandate = value;
    }

    $onInit(): void {
        this.initDebtor(this.wizardCtrl.context.debtor);

        if (this.wizardCtrl.currentStep().wzData != null) {
            return;
        }

        this.wizardCtrl.currentStep().wzData = {};

        this.authService.userLoginPromise.promise.then((res) => {
            this.wizardCtrl.currentStep().wzData.authUser = res;

            this.Shipper.get(
                { id: this.authUser.referenceId },
                (res: Shipper) => {
                    this.wizardCtrl.currentStep().wzData.shipper = res;
                }
            );

            this.Shipper.shipperPremiumServicesBillingAddress(
                { id: this.authUser.referenceId },
                (res: ShipperPremiumServiceBillingAddressCreationDto) => {
                    this.initDebtor(res);
                }
            );
        });
    }

    initDebtor(debtor: ShipperPremiumServiceBillingAddressCreationDto) {
        this.wizardCtrl.context.debtor = debtor;
        this.debtor = angular.copy(debtor);
    }

    saveDebtorDetails() {
        this.wizardCtrl.context.debtor = angular.copy(this.debtor);
    }

    submit(isValid: boolean) {
        if (!isValid) return false;
        this.wizardCtrl.next();
        return true;
    }
}

angular.module('app').component('pkpShipperPremiumServicesWizardSepaMandate', {
    controller: ShipperPremiumServicesWizardSepaMandateComponentCtrl,
    template:
        require('app/shipper-premium-services-wizard/shipper-premium-services-wizard-sepa-mandate.component.html'),
    bindings: {
        back: '&'
    },
    require: {
        wizardCtrl: '^^wizard'
    }
});
